import DivideCarFourSymbol from 'components/elements/symbols/DamagedPart/DivideCarFourSymbol'
import React, { useCallback } from 'react'
import styled from 'styled-components'

import ItemLine from '../ItemLine'
import { DamageProps } from './'
import DamagedPartCheck, { PartPositionProps } from './DamagedPartCheck'

export const DIVIDE_CAR_FOUR_PART_KEYS = [
  'leftFront',
  'rightFront',
  'leftRear',
  'rightRear',
] as const

/**
 * 型定義：前後左右4分割の車のパーツ
 */
export type DivideCarFourPartKeyProps = typeof DIVIDE_CAR_FOUR_PART_KEYS[number]

/**
 * 対象がDivideCarFourPartKeyProps型かチェックする
 * @param target チェック対象
 */
export const isDivideCarFourPartKeyProps = (
  target: any
): target is DivideCarFourPartKeyProps => {
  return DIVIDE_CAR_FOUR_PART_KEYS.includes(target)
}

/**
 * 対象がDivideCarFourLineProps型かチェックする
 * @param target チェック対象
 */
export const isDivideCarFourLineProps = (
  target: any
): target is DivideCarFourLineProps => {
  return (
    target.leftFront !== undefined &&
    target.rightFront !== undefined &&
    target.leftRear !== undefined &&
    target.rightRear !== undefined
  )
}

/**
 * 破損箇所行
 * 前後左右4分割の車
 */
const DivideCarFourLine: React.FC<DivideCarFourLineProps> = (props) => {
  const partDefines: Array<
    PartPositionProps & {
      partKey: DivideCarFourPartKeyProps
    }
  > = [
    // 左上から描画するため、順番を変えるのはNG
    { partKey: 'rightFront', left: '28%', top: '4%' },
    { partKey: 'rightRear', right: '28%', top: '4%' },
    { partKey: 'leftFront', left: '28%', bottom: '4%' },
    { partKey: 'leftRear', right: '28%', bottom: '4%' },
  ]

  const toggleDamage = useCallback((partKey: string): void => {
    if (!props.toggleDamagedPart || !isDivideCarFourPartKeyProps(partKey)) {
      return
    }
    props.toggleDamagedPart(partKey)
  }, [])

  return (
    <ItemLine variableHeight showLineBorder>
      <SymbolArea>
        <DivideCarFourSymbol />
        <CheckOverlayArea>
          {partDefines.map((partDefine) => (
            <CheckOverlayWrapper
              key={partDefine.partKey}
              onClick={(): void => {
                toggleDamage(partDefine.partKey)
              }}
            >
              <DamagedPartCheck
                {...partDefine}
                {...props[partDefine.partKey]}
              />
            </CheckOverlayWrapper>
          ))}
        </CheckOverlayArea>
      </SymbolArea>
    </ItemLine>
  )
}

export type DivideCarFourLineProps = {
  leftFront: DamageProps
  rightFront: DamageProps
  leftRear: DamageProps
  rightRear: DamageProps
  toggleDamagedPart?: (partKey: DivideCarFourPartKeyProps) => void
}

const SymbolArea = styled.div`
  position: relative;
  width: 100%;
  max-width: 640px;
  height: 100%;
  margin: 0 auto;
  padding: 32px 16px;
`

const CheckOverlayArea = styled.div`
  position: absolute;
  top: 12px;
  right: 12.5%;
  bottom: 20px;
  left: 12.5%;
  display: flex;
  flex-wrap: wrap;
`

const CheckOverlayWrapper = styled.div`
  flex-basis: 50%;
  height: 50%;
`

export default DivideCarFourLine
